import { price as priceUtils } from '@eti/utils';
import PropTypes from 'prop-types';
import { Stack, Text } from '@etg/wings';
import { productIds } from '@eti/products';
import { ScreenReaderPrice } from '@eti/components';
import { CartRow, Price } from '../../cart/components/CartComponents';
import CartBreakdownRow from '../../cart/components/CartBreakdownRow';

const AddedExtraProducts = ({ extraProducts = [] }) => {
  return (
    <Stack as="ul" data-testid="postBooking-added-extra-products" spacing={4}>
      {extraProducts.map(({ id, numberOfUnits, title, price, availability }) => {
        if (availability && availability.hasAvailability) {
          return (
            <CartBreakdownRow
              availability={availability}
              dataTestId={`cart-product-${productIds[Number(id)]}`}
              key={id}
              price={price}
              title={title}
            />
          );
        }

        return (
          <CartRow data-testid={`cart-product-${productIds[Number(id)]}`} id={id} key={id}>
            <Text>{numberOfUnits ? `${numberOfUnits} ${title}` : title}</Text>
            <Price aria-hidden>{priceUtils.formatPrice(price)}</Price>
            <ScreenReaderPrice price={priceUtils.formatPrice(price)} />
          </CartRow>
        );
      })}
    </Stack>
  );
};

AddedExtraProducts.propTypes = {
  extraProducts: PropTypes.arrayOf(PropTypes.object),
};

export default AddedExtraProducts;
